import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { FormField, FormType } from '@troia-v3/types';
import { api, type ApiResponse } from '@/lib/api';

/** Resposta de `GET /api/forms/:id/fields` (rota cross-module, app + auth). */
export interface FormFieldsResponse {
  id: string;
  name: string;
  type: FormType;
  fields: FormField[];
}

export interface UseFormFieldsOptions {
  /** `true` = todos os campos (preenchimento na modal de captura). Default: só campos de escolha (filtros do CRM). */
  all?: boolean;
  /** Condicionar a `isOpen`/presença do id (CLAUDE.md SEMPRE #10). */
  enabled?: boolean;
}

/**
 * Campos do modelo de formulário sem exigir permissão do módulo `forms` —
 * o gestor do CRM monta os filtros e o vendedor preenche a captura com isto.
 */
export const useFormFields = (
  formId: string | undefined,
  options: UseFormFieldsOptions = {},
): UseQueryResult<FormFieldsResponse, Error> => {
  const all = options.all === true;
  return useQuery({
    queryKey: ['form-fields', formId, all],
    queryFn: async () => {
      const response = await api.get<ApiResponse<FormFieldsResponse>>(`/forms/${formId}/fields`, {
        params: all ? { all: 'true' } : undefined,
      });
      return response.data.data as FormFieldsResponse;
    },
    enabled: (options.enabled ?? true) && !!formId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
